import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title mb-0" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "mt-4 variable-picker-wrapper" }
const _hoisted_26 = {
  key: 0,
  class: "mt-4 variable-picker-wrapper"
}

import { ref, computed, onMounted, watch, defineAsyncComponent, nextTick } from "vue";
import { useCrud } from "@/composables/commen/useCrud";
import BaseModal from "@/components/commen/modal/BaseModal.vue";
import BaseForm from "@/components/commen/modal/BaseForm.vue"; 
import apiService from "@/services/apiService";
import CommonTable from "@/components/commen/table/CommonTable.vue";
import VariablePicker from "@/components/commen/modal/VariablePicker.vue";
import { usePermissions } from "@/composables/usePermissions";

const API_RESOURCE = "/common/prompt-variables";
const pageTitle = "Prompt Variables";
const title = "Prompt Variables List";


export default /*@__PURE__*/_defineComponent({
  __name: 'promptVariablesList',
  setup(__props) {

const { canCreate } = usePermissions();

const moduleOptions = ref<Array<{ _id: string; title: string }>>([]);
const typeOptions = ref<Array<{ _id: string; title: string }>>([]);
const allVariables = ref<any[]>([]);

const crud = useCrud(API_RESOURCE);

// Tab state
const activeTab = ref<'default' | 'byusers'>('default');
const isLoading = ref(false);
const error = ref<string | null>(null);
const promptVariables = ref<any[]>([]);
const toSlug = (s: string) =>
  (s ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

// Variable management functions
// Function to automatically update raw description when variables are selected/deselected
const updateRawDescriptionWithSelectedVariables = (formData: any, newVars: any[] | undefined, oldVars: any[] | undefined) => {
  console.log('updateRawDescriptionWithSelectedVariables called:', { newVars, oldVars, rawDesc: formData.raw_description });
  
  // Handle undefined arrays
  const safeNewVars = newVars || [];
  const safeOldVars = oldVars || [];
  
  let rawDesc = formData.raw_description || '';
  
  // Find newly selected variables (in newVars but not in oldVars)
  const addedVars = safeNewVars.filter(newVar => 
    !safeOldVars.some(oldVar => oldVar._id === newVar._id)
  );
  
  // Find deselected variables (in oldVars but not in newVars)
  const removedVars = safeOldVars.filter(oldVar => 
    !safeNewVars.some(newVar => newVar._id === oldVar._id)
  );
  
  console.log('Variables change:', { addedVars, removedVars });
  
  // Add slugs for newly selected variables
  addedVars.forEach(variable => {
    if (variable && variable.slug && variable.slug.trim()) {
      const slug = `{${variable.slug}}`;
      console.log('Adding slug:', slug, 'to description:', rawDesc);
      if (!rawDesc.includes(slug)) {
        rawDesc = rawDesc + (rawDesc.trim() ? ' ' : '') + slug;
        console.log('Updated description after adding:', rawDesc);
      }
    }
  });
  
  // Remove slugs for deselected variables
  removedVars.forEach(variable => {
    if (variable && variable.slug && variable.slug.trim()) {
      const slug = `{${variable.slug}}`;
      console.log('Removing slug:', slug, 'from description:', rawDesc);
      // Use a more precise regex to remove the slug and surrounding spaces
      const escapedSlug = slug.replace(/[{}]/g, '\\$&');
      rawDesc = rawDesc.replace(new RegExp(`\\s*${escapedSlug}\\s*`, 'g'), ' ').replace(/\s+/g, ' ').trim();
      console.log('Updated description after removing:', rawDesc);
    }
  });
  
  console.log('Final raw description update:', rawDesc);
  formData.raw_description = rawDesc;
};

const updateDescriptionWithVariables = (formData: any) => {
  console.log('📝 updateDescriptionWithVariables called with:', {
    raw_description: formData.raw_description,
    selectedVariables: formData.selectedVariables?.map((v: any) => ({ title: v.title, slug: v.slug })) || []
  });
  
  const baseDescription = (formData.raw_description || '').trim();
  const selectedVars = formData.selectedVariables || [];
  
  console.log('📝 Base description:', baseDescription);
  console.log('📝 Selected vars count:', selectedVars.length);
  
  // Replace variable slugs with their actual descriptions
  let finalDescription = baseDescription;
  
  if (selectedVars && selectedVars.length > 0) {
    selectedVars.forEach((variable: any) => {
      if (variable && variable.slug && variable.description) {
        const slug = `{${variable.slug}}`;
        console.log('📝 Replacing slug:', slug, 'with description:', variable.description);
        
        // Replace all occurrences of the slug with the variable's description
        const escapedSlug = slug.replace(/[{}]/g, '\\$&');
        finalDescription = finalDescription.replace(new RegExp(escapedSlug, 'g'), variable.description);
      }
    });
    
    console.log('📝 After slug replacement:', finalDescription);
  } else {
    console.log('📝 No variables selected, using base description as-is');
  }
  
  // Update description
  formData.description = finalDescription;
  console.log('📝 FINAL RESULT - Updated description to:', finalDescription);
  console.log('📝 Form data description field is now:', formData.description);
};

// Computed properties
const currentTabTitle = computed(() => 
  activeTab.value === 'default' ? 'Default Prompt Variables' : 'By Users Prompt Variables'
);

// Process prompt variables data for table display
const processedPromptVariables = computed(() => 
  promptVariables.value.map(variable => ({
    ...variable,
    module_title: variable.prompt_category_id?.title || 
                  (typeof variable.prompt_category_id === 'string' 
                    ? moduleOptions.value.find(m => m._id === variable.prompt_category_id)?.title 
                    : 'Unknown Category'),
    type_title: variable.type_id?.title || 
                (typeof variable.type_id === 'string' 
                  ? typeOptions.value.find(t => t._id === variable.type_id)?.title 
                  : 'No Type')
  }))
);

// Updated table configuration to use processed data and conditional actions
const tableConfig = computed(() => ({
  columns: [
    { name: "Title", field: "title", sortable: true, width:"160px" },
    { name: "Category", field: "module_title", sortable: true, width:"160px"  },
    { name: "Type", field: "type_title", sortable: true, width:"130px"  },
    { name: "Prompt", field: "description", sortable: true },
  ],
  data: processedPromptVariables.value,
  actions: activeTab.value === 'default' ? [true] : [false], // Only show actions for default tab
  loading: isLoading.value
}));

// --- Modal State ---
const isCreateModalOpen = ref(false);
const isEditModalOpen = ref(false);
const isViewMode = ref(false);

// --- Form Data ---
const newItemData = ref({
  prompt_category_id: "",
  type_id: null as string | null,
  title: "",
  description: "",
  raw_description: "",
  slug: "",
  selectedVariables: [] as Array<{_id: string; title: string; description: string; slug: string}>,
  // NEW: checkboxes (default false)
  filterable: false,
  visible_on_card: false,
});

const editingItemData = ref({
  _id: "",
  prompt_category_id: "",
  type_id: null as string | null,
  title: "",
  description: "",
  raw_description: "",
  slug: "",
  selectedVariables: [] as Array<{_id: string; title: string; description: string; slug: string}>,
  // NEW: checkboxes
  filterable: false,
  visible_on_card: false,
});

// Function to parse existing description and extract raw description with variables
const parseExistingDescription = (finalDescription: string, allVariables: any[]) => {
  console.log('🔍 Parsing existing description:', finalDescription);
  console.log('🔍 Available variables for parsing:', allVariables?.length || 0);
  
  let rawDescription = finalDescription;
  const selectedVars: any[] = [];
  
  // Try to reverse-engineer the original raw description by finding variable descriptions
  // and replacing them back with slugs
  if (allVariables && allVariables.length > 0) {
    allVariables.forEach((variable: any) => {
      if (variable.description && variable.slug) {
        // Check if this variable's description appears in the final description
        if (finalDescription.includes(variable.description)) {
          console.log(`🔍 Found variable "${variable.title}" description in final prompt`);
          
          // Replace the description with the slug
          const slug = `{${variable.slug}}`;
          rawDescription = rawDescription.replace(variable.description, slug);
          
          // Add to selected variables
          selectedVars.push({
            _id: variable._id,
            title: variable.title,
            description: variable.description,
            slug: variable.slug
          });
        }
      }
    });
  }
  
  console.log('🔍 Parsed result:', { rawDescription, selectedVars: selectedVars.map(v => v.title) });
  
  return {
    rawDescription: rawDescription,
    selectedVars: selectedVars
  };
};

const isCardCategoryCreate = computed(() => {
  const sel = moduleOptions.value.find(m => m._id === newItemData.value.prompt_category_id);
  return (sel?.title || "").trim().toLowerCase() === "card";
});
const isCardCategoryEdit = computed(() => {
  const sel = moduleOptions.value.find(m => m._id === editingItemData.value.prompt_category_id);
  return (sel?.title || "").trim().toLowerCase() === "card";
});

// Watch for raw description changes to auto-deselect variables when slugs are removed
watch(() => newItemData.value.raw_description, (newDesc) => {
  console.log('🔍 Create form - raw_description changed:', newDesc);
  console.log('🔍 Current selected variables:', newItemData.value.selectedVariables?.map(v => ({ title: v.title, slug: v.slug })));
  
  // Auto-deselect variables whose slugs were manually removed
  if (newItemData.value.selectedVariables && newItemData.value.selectedVariables.length > 0) {
    console.log('🔍 Checking which variables should remain selected...');
    
    const remainingVars = newItemData.value.selectedVariables.filter(variable => {
      const slug = `{${variable.slug}}`;
      const isPresent = newDesc && newDesc.includes(slug);
      console.log(`🔍 Variable "${variable.title}" with slug "${slug}" is ${isPresent ? 'PRESENT' : 'MISSING'} in: "${newDesc}"`);
      return isPresent;
    });
    
    console.log('🔍 Variables that should remain:', remainingVars.map(v => v.title));
    
    if (remainingVars.length !== newItemData.value.selectedVariables.length) {
      console.log('🔄 Auto-deselecting variables with removed slugs');
      console.log('Before:', newItemData.value.selectedVariables.map(v => v.title));
      console.log('After:', remainingVars.map(v => v.title));
      
      // Update selected variables
      newItemData.value.selectedVariables = remainingVars;
      
      // Force update the final prompt after deselection
      nextTick(() => {
        console.log('🔄 Force updating final prompt after auto-deselection');
        console.log('🔄 Selected variables after nextTick:', newItemData.value.selectedVariables?.map(v => v.title));
        updateDescriptionWithVariables(newItemData.value);
      });
      return; // Don't update twice
    }
  }
  
  updateDescriptionWithVariables(newItemData.value);
}, { immediate: true });

// Reactive description updates handled by watchers

watch(() => newItemData.value.title, (val) => {
  newItemData.value.slug = toSlug(val);
});
watch(() => editingItemData.value.title, (val) => {
  editingItemData.value.slug = toSlug(val);
});

// Watch for variable selection changes
watch(() => newItemData.value.selectedVariables, (newVars, oldVars) => {
  console.log('🔥 CREATE WATCHER FIRED 🔥', { newVars, oldVars, currentRawDesc: newItemData.value.raw_description });
  
  // Simple direct approach - just add all selected variable slugs
  if (newVars && newVars.length > 0) {
    let baseText = newItemData.value.raw_description || '';
    // Remove any existing slugs first
    baseText = baseText.replace(/\{[^}]+\}/g, '').trim();
    
    // Add all selected variable slugs
    console.log('Processing variables for slugs:', newVars.map(v => ({ title: v.title, slug: v.slug })));
    const slugs = newVars.filter(v => v.slug).map(v => `{${v.slug}}`);
    console.log('Generated slugs:', slugs);
    if (slugs.length > 0) {
      baseText = baseText + (baseText ? ' ' : '') + slugs.join(' ');
      console.log('Combined baseText with slugs:', baseText);
    }
    
    console.log('Directly updating raw_description to:', baseText);
    newItemData.value.raw_description = baseText;
    console.log('After update - raw_description is now:', newItemData.value.raw_description);
  } else {
    // No variables selected, remove slugs
    let baseText = newItemData.value.raw_description || '';
    baseText = baseText.replace(/\{[^}]+\}/g, '').trim();
    console.log('No variables selected, updating raw_description to:', baseText);
    newItemData.value.raw_description = baseText;
    console.log('After clearing - raw_description is now:', newItemData.value.raw_description);
  }
  
  updateDescriptionWithVariables(newItemData.value);
}, { deep: true, immediate: true });

watch(() => editingItemData.value.selectedVariables, (newVars, oldVars) => {
  console.log('Edit form - selectedVariables changed:', { newVars, oldVars, currentRawDesc: editingItemData.value.raw_description });
  
  // Simple direct approach - just add all selected variable slugs
  if (newVars && newVars.length > 0) {
    let baseText = editingItemData.value.raw_description || '';
    // Remove any existing slugs first
    baseText = baseText.replace(/\{[^}]+\}/g, '').trim();
    
    // Add all selected variable slugs
    console.log('Processing variables for slugs:', newVars.map(v => ({ title: v.title, slug: v.slug })));
    const slugs = newVars.filter(v => v.slug).map(v => `{${v.slug}}`);
    console.log('Generated slugs:', slugs);
    if (slugs.length > 0) {
      baseText = baseText + (baseText ? ' ' : '') + slugs.join(' ');
      console.log('Combined baseText with slugs:', baseText);
    }
    
    console.log('Directly updating raw_description to:', baseText);
    editingItemData.value.raw_description = baseText;
    console.log('After update - raw_description is now:', editingItemData.value.raw_description);
  } else {
    // No variables selected, remove slugs
    let baseText = editingItemData.value.raw_description || '';
    baseText = baseText.replace(/\{[^}]+\}/g, '').trim();
    console.log('No variables selected, updating raw_description to:', baseText);
    editingItemData.value.raw_description = baseText;
    console.log('After clearing - raw_description is now:', editingItemData.value.raw_description);
  }
  
  updateDescriptionWithVariables(editingItemData.value);
}, { deep: true, immediate: true });



watch(() => editingItemData.value.raw_description, (newDesc) => {
  console.log('Edit form - raw_description changed:', newDesc);
  
  // Auto-deselect variables whose slugs were manually removed
  if (editingItemData.value.selectedVariables && editingItemData.value.selectedVariables.length > 0) {
    const remainingVars = editingItemData.value.selectedVariables.filter(variable => {
      const slug = `{${variable.slug}}`;
      return newDesc && newDesc.includes(slug);
    });
    
    if (remainingVars.length !== editingItemData.value.selectedVariables.length) {
      console.log('🔄 Auto-deselecting variables with removed slugs');
      console.log('Before:', editingItemData.value.selectedVariables.map(v => v.title));
      console.log('After:', remainingVars.map(v => v.title));
      editingItemData.value.selectedVariables = remainingVars;
      
      // Force update the final prompt after deselection
      nextTick(() => {
        console.log('🔄 Force updating final prompt after auto-deselection');
        updateDescriptionWithVariables(editingItemData.value);
      });
      return; // Don't update twice
    }
  }
  
  updateDescriptionWithVariables(editingItemData.value);
}, { immediate: true });

// Variable selection handlers are now handled by watchers automatically
// --- Form Fields ---
const createFormFields = computed(() => {
  const fields: any[] = [
    {
      key: "prompt_category_id",
      label: "Prompt Category",
      type: "select",
      required: true,
      placeholder: "Select Category",
      options: moduleOptions.value
    },
    {
      key: "title",
      label: "Title",
      type: "text",
      required: true,
      placeholder: "Enter title"
    },
    {
      key: "type_id",
      label: "Type",
      type: "select",
      required: true,
      placeholder: "Select Type",
      options: typeOptions.value
    },
    {
      key: "raw_description",
      label: "Base Prompt Description",
      type: "textarea",
      required: true,
      placeholder: "Enter base prompt description"
    },
    {
      key: "description",
      label: "Final Prompt (Auto-generated)",
      type: "textarea",
      required: false,
      readonly: true,
      placeholder: "This will be auto-generated from base description + selected variables"
    },
  ];

  // Only show these when Category is "Card"
  if (isCardCategoryCreate.value) {
    fields.push(
      {
        key: "filterable",
        label: "Filterable",
        type: "checkbox",
        required: false,
        readonly: isViewMode.value,
      },
      {
        key: "visible_on_card",
        label: "Visible on Card",
        type: "checkbox",
        required: false,
        readonly: isViewMode.value,
      }
    );
  }
  return fields;
});

const editFormFields = computed(() => {
  const fields: any[] = [
    {
      key: "prompt_category_id",
      label: "Prompt Category",
      type: "select",
      required: true,
      placeholder: "Select Category",
      options: moduleOptions.value,
      readonly: isViewMode.value
    },
    {
      key: "title",
      label: "Title",
      type: "text",
      required: true,
      placeholder: "Enter title",
      readonly: isViewMode.value
    },
    {
      key: "type_id",
      label: "Type",
      type: "select",
      required: true,
      placeholder: "Select Type",
      options: typeOptions.value,
      readonly: isViewMode.value
    },
    {
      key: "raw_description",
      label: "Base Prompt Description",
      type: "textarea",
      required: true,
      placeholder: "Enter base prompt description",
      readonly: isViewMode.value
    },
    {
      key: "description",
      label: "Final Prompt (Auto-generated)",
      type: "textarea",
      required: false,
      readonly: true,
      placeholder: "This will be auto-generated from base description + selected variables"
    },
  ];

  if (isCardCategoryEdit.value) {
    fields.push(
      {
        key: "filterable",
        label: "Filterable",
        type: "checkbox",
        required: false,
        readonly: isViewMode.value,
      },
      {
        key: "visible_on_card",
        label: "Visible on Card",
        type: "checkbox",
        required: false,
        readonly: isViewMode.value,
      }
    );
  }
  return fields;
});

// --- Validation ---
const isCreateFormValid = computed(
  () =>
    !newItemData.value.title.trim() ||
    !newItemData.value.prompt_category_id.trim() ||
    !newItemData.value.raw_description.trim()
);
const isEditFormValid = computed(
  () =>
    !editingItemData.value.title?.trim() ||
    !editingItemData.value.prompt_category_id?.trim() ||
    !editingItemData.value.raw_description?.trim()
);

// Tab methods
const setActiveTab = async (tab: 'default' | 'byusers') => {
  activeTab.value = tab;
  // Ensure lookup data is fresh before fetching variables
  if (moduleOptions.value.length === 0 || typeOptions.value.length === 0) {
    await fetchModulesAndTypes();
  }
  await fetchPromptVariables();
};

const fetchPromptVariables = async () => {
  isLoading.value = true;
  error.value = null;
  
  try {
    console.log(`Fetching ${activeTab.value} prompt variables...`);
    const isDefault = activeTab.value === 'default';
    const endpoint = `/common/prompt-variables-filtered?default=${isDefault}`;
    const response = await apiService.get(endpoint);
    console.log('Prompt Variables API Response:', response);
    
    if (Array.isArray(response)) {
      promptVariables.value = response;
      console.log(`Loaded ${promptVariables.value.length} ${activeTab.value} prompt variables`);
    } else if (response && response.data && Array.isArray(response.data)) {
      promptVariables.value = response.data;
      console.log(`Loaded ${promptVariables.value.length} ${activeTab.value} prompt variables`);
    } else {
      console.error('Unexpected response structure:', response);
      throw new Error('Invalid response format');
    }
  } catch (err: any) {
    console.error('Error fetching prompt variables:', err);
    error.value = err?.response?.data?.message || err?.message || 'Failed to load prompt variables';
  } finally {
    isLoading.value = false;
  }
};

// --- Handlers ---
const handleEdit = async (row: any) => {
  isViewMode.value = false;
  
  // Load all variables for parsing
  let allVars: any[] = [];
  try {
    const res = await apiService.get('/common/prompt-variables');
    allVars = (res && res.data && Array.isArray(res.data)) ? res.data : (Array.isArray(res) ? res : []);
  } catch (error) {
    console.error('Error loading variables:', error);
  }
  
  const { rawDescription, selectedVars } = parseExistingDescription(row.description || '', allVars);
  
  editingItemData.value = {
    ...row,
    raw_description: rawDescription,
    selectedVariables: selectedVars,
    prompt_category_id:
      typeof row.prompt_category_id === "object"
        ? row.prompt_category_id._id
        : row.prompt_category_id,
    type_id:
      typeof row.type_id === "object"
        ? row.type_id._id
        : (row.type_id ?? null),
    slug: row.slug ?? toSlug(row.title || ""),
    // default fallbacks for booleans
    filterable: !!row.filterable,
    visible_on_card: !!row.visible_on_card,
  };
  isEditModalOpen.value = true;
};

const handleView = async (row: any) => {
  isViewMode.value = true;
  
  // For view mode, just show the final description as raw description
  const rawDescription = row.raw_description || row.description || '';
  const selectedVars: any[] = [];
  
  editingItemData.value = {
    ...row,
    raw_description: rawDescription,
    selectedVariables: selectedVars,
    filterable: !!row.filterable,
    visible_on_card: !!row.visible_on_card,
    slug: row.slug ?? toSlug(row.title || ""),
  };
  isEditModalOpen.value = true;
};

const handleDelete = async (id: string) => {
  if (confirm("Are you sure you want to delete this item?")) {
    await crud.deleteItem(id);
    await fetchPromptVariables(); // Refresh the current tab data
  }
};

// Normalize empty type_id to null before sending
const normalizeTypeId = (v: any) =>
  (typeof v === "string" ? v.trim() : v) ? v : null;

const handleSaveCreate = async () => {
  if (isCreateFormValid.value) return;
  newItemData.value.slug = toSlug(newItemData.value.title);
  const payload = {
    ...newItemData.value,
    type_id: normalizeTypeId(newItemData.value.type_id),
  };

  const result = await crud.createItem(payload);
  if (result) {
    closeCreateModal();
    await fetchPromptVariables(); // Refresh the current tab data
    newItemData.value = {
      prompt_category_id: "",
      type_id: null,
      title: "",
      slug: "",
      description: "",
      raw_description: "",
      selectedVariables: [],
      filterable: false,
      visible_on_card: false,
    };
  }
};

const handleSaveEdit = async () => {
  const id = editingItemData.value._id;
  if (!id) return;
  const { _id, ...rest } = editingItemData.value;

  const payload = {
    ...rest,
    type_id: normalizeTypeId(rest.type_id),
  };

  const result = await crud.updateItem(id, payload);
  if (result) {
    closeEditModal();
    await fetchPromptVariables(); // Refresh the current tab data
  }
};

const openCreateModal = () => {
  isCreateModalOpen.value = true;
  // Initialize with empty data and trigger description update
  setTimeout(() => {
    updateDescriptionWithVariables(newItemData.value);
  }, 100);
};

const onCreateModalShown = () => {
  console.log('Create modal shown, initializing description');
  updateDescriptionWithVariables(newItemData.value);
};

const onEditModalShown = () => {
  console.log('Edit modal shown, initializing description');
  updateDescriptionWithVariables(editingItemData.value);
};

// Automatic variable selection handles slug insertion/removal

const closeCreateModal = () => {
  isCreateModalOpen.value = false;
  isViewMode.value = false;
  newItemData.value = {
    prompt_category_id: "",
    type_id: null,
    title: "",
    description: "",
    raw_description: "",
    slug: "",
    selectedVariables: [],
    filterable: false,
    visible_on_card: false,
  };
};

const closeEditModal = () => {
  isEditModalOpen.value = false;
  isViewMode.value = false;
  editingItemData.value = {
    _id: "",
    prompt_category_id: "",
    type_id: null,
    title: "",
    slug: "",   
    description: "",
    raw_description: "",
    selectedVariables: [],
    filterable: false,
    visible_on_card: false,
  };
};

// --- Load data ---
onMounted(async () => {
  // Load the lookup data first, then the prompt variables
  await fetchModulesAndTypes();
  await fetchPromptVariables();
});

const fetchModulesAndTypes = async () => {
  try {
    const res = await apiService.get("common/prompt-categories");
    // Handle both wrapped {.data: [...]} and direct array responses
    moduleOptions.value = (res && res.data && Array.isArray(res.data)) 
      ? res.data 
      : (Array.isArray(res) ? res : []);

    const typ = await apiService.get("common/variable-types");
    typeOptions.value = (typ && typ.data && Array.isArray(typ.data)) 
      ? typ.data 
      : (Array.isArray(typ) ? typ : []);
    
    // Load all variables for the variable picker
    const vars = await apiService.get("common/prompt-variables");
    allVariables.value = (vars && vars.data && Array.isArray(vars.data)) 
      ? vars.data 
      : (Array.isArray(vars) ? vars : []);
    
    console.log(allVariables.value,"allVariables.value");
  } catch {
    moduleOptions.value = [];
    typeOptions.value = [];
    allVariables.value = [];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'default' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('default'))),
              type: "button"
            }, " Default ", 2)
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'byusers' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('byusers'))),
              type: "button"
            }, " By Users ", 2)
          ])
        ]),
        (activeTab.value === 'default')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: openCreateModal,
              disabled: !_unref(canCreate)('main')
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fa fa-plus me-2" }, null, -1),
              _createTextVNode(" Create New Prompt Variable ", -1)
            ]))], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(currentTabTitle.value), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)),
                _createElementVNode("p", _hoisted_12, "Loading " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " prompt variables...", 1)
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Error:", -1)),
                      _createTextVNode(" " + _toDisplayString(error.value), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: fetchPromptVariables
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                      _createTextVNode(" Retry ", -1)
                    ]))])
                  ])
                ]))
              : (promptVariables.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(CommonTable, {
                      tableObj: tableConfig.value,
                      title: '',
                      permissionKey: "main",
                      onEdit: handleEdit,
                      onDelete: handleDelete,
                      onView: handleView
                    }, null, 8, ["tableObj"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-3" }, [
                      _createElementVNode("i", { class: "fa fa-code fa-3x text-muted" })
                    ], -1)),
                    _createElementVNode("h5", _hoisted_18, "No " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " Prompt Variables Found", 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(activeTab.value === 'default' 
              ? 'No default prompt variables are available.' 
              : 'No By Users prompt variables are available.'), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (activeTab.value === 'default')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary me-2",
                            onClick: openCreateModal,
                            disabled: !_unref(canCreate)('main')
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                            _createTextVNode(" Create Prompt Variable ", -1)
                          ]))], 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        onClick: fetchPromptVariables
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                        _createTextVNode(" Refresh ", -1)
                      ]))])
                    ])
                  ]))
        ]),
        (promptVariables.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("small", _hoisted_24, " Showing " + _toDisplayString(promptVariables.value.length) + " " + _toDisplayString(activeTab.value === 'default' ? 'default' : 'By Users') + " prompt variable" + _toDisplayString(promptVariables.value.length !== 1 ? 's' : ''), 1),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-secondary",
                  onClick: fetchPromptVariables
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                  _createTextVNode(" Refresh ", -1)
                ]))])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(BaseModal, {
      id: "createNew",
      title: `Create ${pageTitle}`,
      visible: isCreateModalOpen.value,
      onClose: closeCreateModal,
      onSave: handleSaveCreate,
      onShown: onCreateModalShown,
      "save-button-disabled": isCreateFormValid.value,
      "dialog-class": "modal-xl"
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: createFormFields.value,
          modelValue: newItemData.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newItemData).value = $event)),
          onSubmit: handleSaveCreate,
          ref: "createFormRef"
        }, null, 8, ["fields", "modelValue"]),
        _createElementVNode("div", _hoisted_25, [
          _cache[16] || (_cache[16] = _createElementVNode("h6", null, "Add Existing Variables", -1)),
          _createVNode(VariablePicker, {
            modelValue: newItemData.value.selectedVariables,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((newItemData.value.selectedVariables) = $event)),
              _cache[4] || (_cache[4] = (value) => { console.log('🎯 VariablePicker emitted update:', value); newItemData.value.selectedVariables = value; })
            ],
            "current-category-id": newItemData.value.prompt_category_id,
            variables: allVariables.value
          }, null, 8, ["modelValue", "current-category-id", "variables"])
        ])
      ]),
      _: 1
    }, 8, ["title", "visible", "save-button-disabled"]),
    _createVNode(BaseModal, {
      id: "editModal",
      title: `${isViewMode.value ? 'View' : 'Edit'} ${pageTitle}`,
      visible: isEditModalOpen.value,
      onClose: closeEditModal,
      onSave: handleSaveEdit,
      onShown: onEditModalShown,
      "show-save-button": !isViewMode.value,
      "save-button-disabled": isEditFormValid.value,
      "dialog-class": "modal-xl"
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: editFormFields.value,
          modelValue: editingItemData.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editingItemData).value = $event)),
          onSubmit: handleSaveEdit,
          ref: "editFormRef"
        }, null, 8, ["fields", "modelValue"]),
        (!isViewMode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _cache[17] || (_cache[17] = _createElementVNode("h6", null, "Add Existing Variables", -1)),
              _createVNode(VariablePicker, {
                modelValue: editingItemData.value.selectedVariables,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingItemData.value.selectedVariables) = $event)),
                "current-category-id": editingItemData.value.prompt_category_id,
                variables: allVariables.value
              }, null, 8, ["modelValue", "current-category-id", "variables"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible", "show-save-button", "save-button-disabled"])
  ], 64))
}
}

})